import React from 'react';
import PropTypes from 'prop-types';
import loadable from 'utils/loadable';
import LoadingIndicator from 'components/LoadingIndicator';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import Divider from 'components/Divider';
import VisibleOnScrollTracking from 'components/VisibleOnScrollTracking';

const Subscribe = loadable(() => import('./components/Subscribe'), {
  fallback: null,
});

const EditorsList = loadable(() => import('./components/EditorsList'), {
  fallback: <LoadingIndicator />,
});

const ResourcesList = loadable(() => import('./components/ResourcesList'), {
  fallback: <LoadingIndicator />,
});

const OriginalsList = loadable(() => import('./components/OriginalsList'), {
  fallback: <LoadingIndicator />,
});
const NewsList = loadable(() => import('./components/NewsList'), {
  fallback: <LoadingIndicator />,
});
const Sponsors = loadable(() => import('components/SponsorFooter'), {
  fallback: null,
});

function Section({ section }) {
  if (section === 'Resources')
    return (
      <VisibleOnScrollTracking section="resources" key="resources">
        <ResourcesList title="Featured Resources" />
      </VisibleOnScrollTracking>
    );
  if (section === 'Blogs')
    return (
      <VisibleOnScrollTracking section="blogs" key="blogs">
        <OriginalsList />
      </VisibleOnScrollTracking>
    );
  if (section === 'News')
    return (
      <>
        <Divider top={66} bottom={55} />
        <VisibleOnScrollTracking section="news">
          <NewsList />
        </VisibleOnScrollTracking>
      </>
    );
  if (section === 'Lists')
    return (
      <>
        <Divider top={43} bottom={60} />
        <VisibleOnScrollTracking section="lists" key="lists">
          <EditorsList />
        </VisibleOnScrollTracking>
      </>
    );
  if (section === 'Sponsors') {
    return (
      <LazyLoadComponent>
        <Sponsors />
      </LazyLoadComponent>
    );
  }
  if (section === 'Subscribe')
    return (
      <LazyLoadComponent>
        <Subscribe />
      </LazyLoadComponent>
    );
  return null;
}

Section.propTypes = {
  section: PropTypes.string,
};

export default Section;
